// extracted by mini-css-extract-plugin
export var footer = "_s7-0";
export var inherit = "_s7-1";
export var input = "_s7-2";
export var modalContent = "_s7-3";
export var quillEditor = "_s7-4";
export var subtitle = "_s7-5";